/**
 * @generated SignedSource<<f406d83a3f22901e26f02feb35431533>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditAccommodation_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AssignHotelToPackageDialog_data" | "PackageEditAccomodationPrices_data">;
  readonly " $fragmentType": "PackageEditAccommodation_data";
};
export type PackageEditAccommodation_data$key = {
  readonly " $data"?: PackageEditAccommodation_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditAccommodation_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditAccommodation_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssignHotelToPackageDialog_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditAccomodationPrices_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "374be8b9619914c0548b9c2058e06685";

export default node;
